import { Box, Skeleton, Card, CardContent, Grid, Stack } from '@mui/material';
import { Container } from '../../../components/container';

export const ClusterDataSkeleton = () => (
  <Container>
    <Box sx={{ mb: 3 }}>
      <Skeleton variant="text" sx={{ fontSize: '2.125rem' }} width="30%" />
    </Box>

    <Card sx={{ mb: 4 }}>
      <CardContent sx={{ p: 3 }}>
        <Grid container spacing={3} columns={5}>
          <Grid size={{ xs: 5, md: 2 }}>
            <Box>
              <Stack spacing={2}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Skeleton variant="circular" width={24} height={24} />
                  <Skeleton variant="text" width={150} />
                </Box>

                <Skeleton variant="text" width="80%" height={48} />

                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 2,
                    mt: 2,
                    p: 2,
                    bgcolor: 'rgba(255, 255, 255, 0.1)',
                    borderRadius: 2,
                  }}
                >
                  <Skeleton variant="circular" width={48} height={48} />
                  <Box sx={{ flex: 1 }}>
                    <Skeleton variant="text" width="60%" height={36} />
                    <Skeleton variant="text" width="80%" />
                  </Box>
                </Box>

                <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', mt: 2 }}>
                  <Box
                    sx={{
                      flex: 1,
                      minWidth: 120,
                      p: 1.5,
                      bgcolor: 'rgba(255, 255, 255, 0.1)',
                      borderRadius: 1,
                    }}
                  >
                    <Skeleton variant="text" width="60%" />
                    <Skeleton variant="text" width="40%" height={32} />
                  </Box>
                  <Box
                    sx={{
                      flex: 1,
                      minWidth: 120,
                      p: 1.5,
                      bgcolor: 'rgba(255, 255, 255, 0.1)',
                      borderRadius: 1,
                    }}
                  >
                    <Skeleton variant="text" width="60%" />
                    <Skeleton variant="text" width="40%" height={32} />
                  </Box>
                </Box>

                <Box sx={{ mt: 2, p: 2, bgcolor: 'rgba(255, 255, 255, 0.1)', borderRadius: 2 }}>
                  <Skeleton variant="rectangular" width="100%" height={80} sx={{ borderRadius: 1 }} />
                </Box>
              </Stack>
            </Box>
          </Grid>
          <Grid size={{ xs: 5, md: 3 }}>
            <Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                <Skeleton variant="circular" width={24} height={24} />
                <Skeleton variant="text" width={150} height={32} />
              </Box>
              <Stack spacing={1.5}>
                {[1, 2, 3].map((item) => (
                  <Skeleton key={item} variant="rectangular" height={56} sx={{ borderRadius: 2 }} />
                ))}
              </Stack>
            </Box>
          </Grid>
        </Grid>
      </CardContent>
    </Card>

    <Card sx={{ borderRadius: 3, mb: 3 }}>
      <CardContent>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Skeleton variant="circular" width={60} height={60} />
          <Box sx={{ flex: 1 }}>
            <Skeleton variant="text" width="40%" sx={{ fontSize: '1.5rem' }} />
            <Skeleton variant="text" width="30%" />
          </Box>
          <Skeleton variant="text" width="15%" sx={{ fontSize: '3rem' }} />
        </Box>
      </CardContent>
    </Card>

    <Box sx={{ mb: 3, maxWidth: 300 }}>
      <Skeleton variant="rectangular" width="100%" height={56} sx={{ borderRadius: 1 }} />
    </Box>

    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
      <Skeleton variant="rectangular" width={40} height={40} sx={{ borderRadius: 1 }} />
      <Skeleton variant="text" width="20%" />
      <Skeleton variant="rectangular" width={40} height={40} sx={{ borderRadius: 1 }} />
    </Box>

    <Grid container spacing={3} mb={4}>
      {[...Array(4)].map((_, index) => (
        <Grid key={index} size={{ xs: 12, md: 6 }}>
          <Card sx={{ borderRadius: 3 }}>
            <CardContent>
              <Skeleton variant="text" width="70%" sx={{ mb: 2, fontSize: '1.25rem' }} />
              <Skeleton variant="rectangular" width="100%" height={250} sx={{ borderRadius: 2 }} />
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>

    <Card sx={{ borderRadius: 3, mb: 4 }}>
      <CardContent>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
          <Box sx={{ flex: 1 }}>
            <Skeleton variant="text" width="40%" sx={{ fontSize: '1.5rem', mb: 1 }} />
            <Skeleton variant="text" width="60%" />
          </Box>
          <Skeleton variant="rectangular" width={140} height={36} sx={{ borderRadius: 1 }} />
        </Box>
        <Skeleton variant="rectangular" width="100%" height={400} sx={{ borderRadius: 2 }} />
      </CardContent>
    </Card>

    <Card sx={{ borderRadius: 3, mb: 4 }}>
      <CardContent>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
          <Box sx={{ flex: 1 }}>
            <Skeleton variant="text" width="40%" sx={{ fontSize: '1.5rem', mb: 1 }} />
            <Skeleton variant="text" width="60%" />
          </Box>
          <Skeleton variant="rectangular" width={140} height={36} sx={{ borderRadius: 1 }} />
        </Box>
        <Skeleton variant="rectangular" width="100%" height={400} sx={{ borderRadius: 2 }} />
      </CardContent>
    </Card>

    <Card sx={{ borderRadius: 3, mb: 4 }}>
      <CardContent>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
          <Skeleton variant="text" width="40%" sx={{ fontSize: '1.5rem' }} />
          <Skeleton variant="rectangular" width={140} height={36} sx={{ borderRadius: 1 }} />
        </Box>
        <Skeleton variant="rectangular" width="100%" height={400} sx={{ borderRadius: 2 }} />
      </CardContent>
    </Card>

    <Card sx={{ borderRadius: 3 }}>
      <CardContent>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
          <Skeleton variant="text" width="40%" sx={{ fontSize: '1.5rem' }} />
          <Skeleton variant="rectangular" width={140} height={36} sx={{ borderRadius: 1 }} />
        </Box>
        <Skeleton variant="rectangular" width="100%" height={300} sx={{ borderRadius: 2 }} />
      </CardContent>
    </Card>
  </Container>
);
